export let generalCtrl = (function (angular) {
  window.app = angular.module('racoongo', ['ngMaterial', 'ngMdIcons', 'ngMessages', 'ngAnimate', 'ngSanitize']);

  window.app.controller('generalCtrl', ['$scope', '$http', '$compile', '$mdDialog', function ($scope, $http, $compile, $mdDialog) {

    // $scope.addClickedClass = function() {
    //     if ($scope.isClicked === true) {
    //         $scope.isClicked = false;
    //         $scope.clicked = '';
    //     } else {
    //         $scope.isClicked = true;
    //         $scope.clicked = 'clicked';
    //     }
    // };

    $scope.boxShow = false;
    $scope.isProd;
    $scope.showSearch = false;
    $scope.checkEnviroment = (isDev) => {
      isDev ? $scope.isProd = false : $scope.isProd = true;
    }

    $scope.removeLocalStorageFilter = {
      removeStorage: function removeStorage() {
        $scope.filterParams = localStorage.removeItem('filterParams');
      }
    };

    $scope.compareList = {
      data: {
        counter: 0,
        links: [
          //{ttl: 'chwilowki', mainPage: 'chwilowki', url: 'url', counter: 0}
        ],
      },
      list: {
        get: () => JSON.parse(localStorage.getItem('cl')),
        set: (list) => {
          localStorage.setItem('cl', JSON.stringify(list))
        }
      },
      createLink: () => {
        let list = $scope.compareList.list.get() || {};
        let compareLinks = [];
        list = Object.entries(list);
        if (list.length) {
          for (let i = 0; i < list.length; i++) {
            let compareLink = {};
            compareLink.ttl = list[i][0];
            compareLink.mainPage = list[i][0];
            compareLink.url = [];
            compareLink.counter = 0;
            let categoryItems = list[i][1];
            for (let i = 0; i < categoryItems.length; i++) {
              compareLink.counter = i + 1
              compareLink.url.push(
                `items[]=${categoryItems[i].id};${categoryItems[i].amount};${categoryItems[i].term}:${categoryItems[i].termDivider}`
              )
            }
            compareLink.url = compareLink.url.join('&');
            compareLinks.push(compareLink);

            $scope.compareList.data.links = compareLinks;

          }
          $scope.compareList.updateCounter()
        } else {
          $scope.compareList.data.counter = 0;
        }
      },
      updateCounter: () => {
        let mainCount = 0;
        let links = $scope.compareList.data.links;
        for (let i = 0; i < links.length; i++) {
          mainCount += links[i].counter
        }
        $scope.compareList.data.counter = mainCount;
      }


    };
    $scope.compareList.createLink();

    $scope.cl = (v) => {
      console.log(v);
    };

    $scope.loaderView;
    $scope.switchLoader = function (s, loaderView) {
      if (s) $(`${loaderView}`).fadeIn(200);
      else {
        setTimeout(function () {
          $(`${loaderView}`).fadeOut(200);
        }, 700)
      }
    };

    $scope.sendXHR = function (params, loader = true, loaderView = '.loader-fullScreen') {
      $scope.loaderView = loaderView;
      /*params = {
          url:  string,
          data:  string/obj,
          method:  string,
          headers:  obj,
          dataAsParam:  bool,
          successFunc:  func,
          errorFunc:  func,
      }*/
      let url = params.url;
      let data = params.data;
      let urlParams = params.params;

      let method = params.method || 'POST';
      let headers = params.headers || { 'Content-Type': 'application/x-www-form-urlencoded' };
      let dataAsParam = params.dataAsParam === undefined ? true : params.dataAsParam;
      let successFunc = params.successFunc;
      let errorFunc = params.errorFunc;

      function getXHRdata() {
        if (dataAsParam) {
          if (typeof data === 'function') return $.param(data());
          return $.param(data);
        } else {
          if (typeof data === 'function') return data();
          return data;
        }
      }

      $scope.switchLoader(loader, $scope.loaderView);
      $http({
        method: method,
        url: url,
        params: urlParams,
        data: getXHRdata(),
        headers: headers

      }).then(function successCallback(response) {
        successFunc ? successFunc(response) : console.log(`XHR sent ${url}`)

        $scope.switchLoader(false, $scope.loaderView);

      }, function errorCallback(response) {
        errorFunc ? errorFunc(response) : $scope.showAlert('error', 'Przepraszamy, wystąpił pewien problem techniczny. Spróbuj ponownie później');

        console.log(`ajax fail...(${response.status}).`);
        $scope.switchLoader(false, $scope.loaderView);
      })
    }

    $scope.setClick = function (el) {
      $(el).click();
    };

    $scope.checkPath = () => {
      let path = document.location.pathname.split('/')[1];
    }

    $scope.isActive = function (viewLocation) {
      return viewLocation === document.location.pathname.split('/')[1];
    }

    $scope.alert = {
      type: '',
      msg: ''
    };

    $scope.customFullscreen = false;

    $scope.showDetail = function (ev) {
      $mdDialog.show({
        template:
          '<md-dialog style="padding: 0px" class="dialog-wide">' +
          '<md-toolbar>' +
          '<div class="md-toolbar-tools" style="background-color: #a8b9c7;min-height: 70px">' +
          '<h2 style="color: white; font-weight: bold">Spójrz na siebie oczami pożyczkodawców</h2>' +
          '<button class="button-detail" ng-click="closeModal()">X</button>' +
          '</div> </md-toolbar>' +
          '<div style="display: flex;flex-direction: column;">' +
          '<div style="margin: 0px 10px 10px;">' +
          '<br>' +
          '<p>Oceń sytuację na poziomie ekspertów kredytowych i uzyskaj przydatne rekomendacje.</p><br><br>' +
          '<ul style="list-style: none">' +
          '<li class="indent">Wyobraź sobie, że JESTEŚ POŻYCZKODAWCOM. Klient przychodzi do Ciebie i wypełnia wniosek o pożyczkę.' +
          'Dla Ciebie to tylko wierzchołek Góry Lodowej, NIE znasz jego historii i czy możesz jemu zaufać?</li><br>' +
          '<li class="indent">Następnie uzupełniasz wiedzę o kliencie - oceniasz klienta na podstawie danych biura CRIF, ustalasz jego zadłużenie na określony moment.' +
          'Dla CIEBIE jest to jedynie przybliżenie do dogłębnej wiedzy o kliencie, ale wciąż pozostaje na powierzchni. Wciąż nie możesz mu ufać.</li><br>' +
          '<li class="indent">Aby uzyskać pełny obraz, należy zwrócić się do BIK i poznać jego pełną historię kredytową, która sięga daleko w przeszłość.' +
          'Dla CIEBIE jest to pełny obraz klienta, TY widzisz całą Górę Lodową. Dogłębnie prześwietliłeś klienta i możesz podjąć decyzję o zaufaniu mu.</li><br>' +
          '</ul><br>' +
          'Dla CIEBIE - Pożyczkodawcy jest bardzo ważne, aby kompleksowo ocenić klienta i poznać jego pełną historię kredytową, zbierając maksimum informacji z różnych źródeł.<br><br>' +
          'Teraz wiesz, w jaki sposób Pożyczkodawcy prześwietlają Cię przed podjęciem decyzji o udzieleniu pożyczki. Dajemy Ci wyjątkową okazję, aby zobaczyć siebie ich oczami.' +
          '</div>' +
          '</div>' +
          '</md-dialog>',

        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: $scope.customFullscreen, // Only for -xs, -sm breakpoints.
        controller: function DialogController($scope, $mdDialog) {
          $scope.closeModal = function () {
            $mdDialog.hide();
          }
        }
      })
    };


    $scope.showAlert = function (typeAlert, message) {
      //typeAlert: (success,info,warning,error)
      $scope.alert = {
        type: typeAlert,
        msg: message
      };
      if ($scope.alert.msg == "Wygląda na to, że próbujesz zalogować się jako użytkownik. Aby wejść na profil użytkownika, kliknij TUTAJ") {
        document.getElementById("alertMsg").innerHTML = `<a target="_blank" href="/login/">Wygląda na to, że próbujesz zalogować się jako użytkownik. Aby wejść na profil użytkownika, kliknij TUTAJ</a>`
      }
      let time = message.length / 15 * 1000 + 1000;
      $scope.$digest();
      setTimeout(function () {
        $scope.setClick('.closeBtn');
      }, time);
    };

    $scope.hideAlert = function () {
      $scope.alert.type = '';
    };

    $scope.showDialog = function (event, content) {
      let dialogProps = {
        template: content[0] !== '#' ? content : '',
        contentElement: content[0] === '#' ? content : '',
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: true,
        escapeToClose: true
      };
      $mdDialog.show(dialogProps);
    };

    $scope.closeDialog = function () {
      $mdDialog.hide();
    };

    //EXIT INTENT POPUP
    // $scope.exitIntentPopUp =
    //   `<div id="modal-popup" class="exit-intent-popup">
    //         <div class="layout" layout-align="end">
    //             <span class="modal-close-btn" ng-click="closeDialog()" aria-label="close">X</span>
    //         </div>
    //         <div class="" style="display: flex; justify-content: space-around; align-items: center;">
    //             <div class="img-wrp hide-xs">
    //                 <img alt="racoon with pointer" style="" src="/front/src/img/racoon-in-circle.png">
    //             </div>
    //             <div>
    //                 <h3 class="has-margin-y1">Chcesz dowiedziec sie jaka jest twoja historie kredytowa?</h3>
    //                 <p>Zostań z nami <span class="hide-xs">a dowiedz się w 5 min</span></p>
    //                     <a ga-on="click,auxclick,contextmenu"
    //                         ga-event-category="Outclick banner"
    //                         ga-event-label="Exit-pop-up Smart Scanner"
    //                         class="action-btn sa-profile-btn has-margin-y1"
    //                         href="/raport/">
    //                         SPRAWDŹ
    //                     </a>
    //             </div>
    //         </div>
    //     </div>`
    //
    // document.addEventListener("mouseleave", function (e) {
    //   if (!sessionStorage.getItem("exitIntentPopUp")) {
    //     if (e.clientY < 0) {
    //       let popupView;
    //       var onRaportPage = window.location.href.includes("raport");
    //       !onRaportPage ? popupView = $scope.exitIntentPopUp : popupView = false;
    //       if (popupView && document.location.pathname.split('/')[1] != "raport") {
    //         sessionStorage.setItem("exitIntentPopUp", "true");
    //         $mdDialog.show({
    //           preserveScope: true,
    //           template: popupView,
    //           parent: angular.element(document.body),
    //           scope: $scope,
    //         });
    //       }
    //     }
    //     $scope.$watch(function () {
    //       if ($("md-dialog > .exit-intent-popup").length > 0) {
    //         $("md-dialog").css({"max-width": "700px", "background": "linear-gradient(to right,#0a81c6,#6ebbe4)"});
    //       }
    //     })
    //   }
    // }, false);

    // EXIT INTENT POPUP FOR MOBILE

    // $(document).on('touchstart', function () {
    //   $("body").addClass('on-mobile-device');
    // });
    // $(document).on('scroll', myScrollSpeedFunction);
    //
    // function myScrollSpeedFunction() {
    //   if (!sessionStorage.getItem("exitIntentPopUp")) {
    //     if ($('body').hasClass('on-mobile-device')) {
    //       let popupView;
    //       var onRaportPage = window.location.href.includes("raport");
    //       onRaportPage ? popupView = $scope.exitIntentPopUp : popupView = false;
    //       if (my_scroll() < -100 && popupView && document.location.pathname.split('/')[1] != "raport") {
    //         sessionStorage.setItem("exitIntentPopUp", "true");
    //         $mdDialog.show({
    //           preserveScope: true,
    //           template: popupView,
    //           parent: angular.element(document.body),
    //           scope: $scope,
    //         });
    //         $scope.$watch('$viewContentLoaded', function () {
    //           let mdDialog = $(".exit-intent-popup").parent();
    //           mdDialog.css({"background": "linear-gradient(to right,#0a81c6,#6ebbe4)"});
    //         })
    //       }
    //     }
    //   }
    // }

    var my_scroll = (function () { //Function that checks the speed of scrolling
      var last_position, new_position, timer, delta, delay = 25;

      function clear() {
        last_position = null;
        delta = 0;
      }

      clear();
      return function () {
        new_position = window.scrollY;
        if (last_position != null) {
          delta = new_position - last_position;
        }
        last_position = new_position;
        clearTimeout(timer);
        timer = setTimeout(clear, delay);
        return delta;
      };
    })();


    //END OF EXIT INTENT POPUP

    //Sticky application
    // $scope.showStickyApp;
    // $scope.checkIfShowStickyApp = () => {
    //     let withoutStickiApp = ["application", "office", "affiliate-program", "o-nas", "regulamin", "polityka-prywatnosci", "polityka-prywatnosci"];
    //     let page = window.location.pathname.slice(1);
    //     page = page.substring(0, page.indexOf("/"));
    //     withoutStickiApp.includes(page) ? $scope.showStickyApp = false : $scope.showStickyApp = true;
    // }
    // $scope.checkIfShowStickyApp();

    // $scope.$on('toogleStickyApp', function (event, data) {
    //     $scope.showStickyApp = data.showStickyApp
    // })
    //END OF Sticky application

    $scope.validateCheckboxes = () => {
      let checkboxes = ["regulamin", "agreement-policy", "agreement-data"]
      for (let i = 0; i < checkboxes.length; i++) {
        $(`#${checkboxes[i]}`).addClass("needToCheck");
      }
      return true;
    }

    $scope.openContactForm = () => {
      $(".contact-form .arrow-btn").hasClass("down") ? $(".contact-form .arrow-btn").removeClass("down").addClass("up") : $(".contact-form .arrow-btn").removeClass("up").addClass("down");
    }

    $scope.redirect = function (link) {
      window.location.pathname = link;
    };

    $scope.getCookie = function (name) {
      const matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    };

    $scope.agreeCookiesRules = function () {
      localStorage.setItem('agreeCookies', 'true');
      $scope.checkCookiesRules();
    };

    $scope.checkCookiesRules = function () {
      if (localStorage.getItem('agreeCookies')) return false;
      return true;
    };

    $scope.serviceData;
    $scope.setServiceData = function (data) {
      $scope.serviceData = data;
    };

    $scope.scrollTo = (el, time) => {
      if ($(el).length) {
        let headerHeight = $(".header").height();
        $('html, body').animate({ scrollTop: $(el).offset().top - headerHeight }, time || 1000);
      }
    };

    $scope.faqExpand = (event) => {
      $(event.target).toggleClass('open').next('.faq_text').slideToggle();
    }


    $scope.hideOnPage = function (page) {
      if (page == document.location.pathname.split('/')[1]) {
        return true;
      }
      return false
    }
    $scope.showOnPage = function (page) {
      if (page == document.location.pathname.split('/')[1]) {
        return true;
      }
      return false
    }
    $scope.toggleFilters = (el) => {
      let filters = $(el);
      filters.toggleClass('open')
      $(".fin-offers__filters").toggleClass('opened-filter')
      let windowHight = $(document).height();
      $(".offers-filters--aside").css("height", windowHight)
    }

    $scope.toggleOneFilter = (el) => {
      let filters = $(el);
      filters.toggleClass('open')
    }
    $scope.showFiltersMobileIcon = () => {
      let page = document.location.pathname.split('/')[1];
      if (page === 'kredyty' || page === 'Chwilówki' || page === 'lokaty-bankowe') {
        return true;
      } else {
        return false;
      }
    }

    (function () {
      $('.burger-container').on('click', function () {
        $('.header').toggleClass('menu-opened');
      })
      $('.compare-btn').on('click', function () {
        $('.ra-dropdown__list').toggleClass('opened');
      })
      $(window).on('load scroll resize', function () {
        if (window.innerWidth >= 993) {
          $('.nav .ra-dropdown').removeClass('opened')
        }
      })
      $('.ra-dropdown__title').on('click', function (event) {
        if ($(window).width() <= 993)
          event.preventDefault();
        if ($(window).width() <= 600) {
          $(this).next('.ra-dropdown').slideToggle();
        }
      });
      // $(function() {
      //     var zIndexNumber = 1000;
      //     // Put your target element(s) in the selector below!
      //     $("div").each(function() {
      //             $(this).css('zIndex', zIndexNumber);
      //             zIndexNumber -= 10;
      //     });
      // });
    }())

    $scope.collapseToggle = (e) => {
      let el = e.target;
      let elParentId = e.target.offsetParent.id;
      if (el.classList.contains('add-to-compare-btn')) {
        $scope.compareList.update(e)
      }
      if (el.classList.contains('btn-show-offer-details')) {
        let offer = $('.offer-' + elParentId);
        let deteils = offer.children('.offer-card__details');
        if (offer.hasClass('details-showed')) deteils.slideToggle('fast');
        else deteils.slideToggle('fast');
        offer.toggleClass('details-showed');
      }
    };

    $scope.searchState = () => {
      console.log('here')
      if ($scope.showSearch === true) {
        $scope.showSearch = false;
      } else if ($scope.showSearch === false) {
        $scope.showSearch = true;
      }
      console.log($scope.showSearch)
    }

    $scope.setCorrectCategoriesName = (name) => {
      if (name === 'chwilowki') {
        name = 'Chwilówki'
      } else if (name === 'pozyczki') {
        name = 'Pożyczki'
      }
      return name;
    };
  }]);

  window.app.controller('hotele', ['$scope', function ($scope) {
    $scope.mainWidgetWidth = function () {
      var c = $('.container')[2].offsetWidth;
      if (c > 1100) return 1100;
      if (c < 1100) return c;
    }

  }])


})(window.angular);


angular.element(window.document.body).ready(function () {
  // if ($(window).width() >= 576) {
  //   $('.dropdown-expand_item').hover(function () {
  //     let dropdownMenu = $(".dropdown-menu-wrp")
  //     let subMenuWidth = $(".main-menu-wrp")[0].clientWidth + "px";
  //     dropdownMenu.css("width", subMenuWidth);
  //   });
  // }


  $('.blockCTRL').click(function () {
    if ($(this).hasClass('open')) {
      $(this).siblings('.blockHidden').slideUp('2000');
      $(this).removeClass('open');
    } else {
      $(this).siblings('.blockHidden').slideDown('2000');
      $(this).addClass('open');
    }
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      $('.btn-to-top').addClass('visible');
    } else {
      $('.btn-to-top').removeClass('visible');
    }
    ;
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() > 30 && window.innerWidth >= 992) {
      $('.header').addClass('sticky');
      $('.offers-filters').addClass('sticky')
    } else {
      $('.header').removeClass('sticky');
      $('.offers-filters').removeClass('sticky')
    }
    ;
  });

});



// WEBPACK FOOTER //
// src/js/controllers/generalCtrl.js